import {createApp} from "vue";
import Slider from "./components/Slider";

jQuery(document).ready(()=>{

    const slidersRoots = document.querySelectorAll('.cccblog-slider');

    slidersRoots.forEach((root) => {
        createApp(Slider, {...root.dataset}).mount(root);
    });

});